export const ACCOUNTING_DEPRECIATION_METHOD_OPTIONS = [
  { value: 'WRITTEN_DOWN_VALUE', label: 'Written Down Value (WDV)' },
  { value: 'STRAIGHT_LINE', label: 'Straight Line Method (SLM)' },
];

export const TAX_ASSET_BLOCK_OPTIONS = [
  { value: 'PLANT_AND_MACHINERY', label: 'Plant and Machinery' },
  { value: 'COMPUTER_AND_SOFTWARE', label: 'Computer and Software' },
  { value: 'FURNITURE_AND_FITTINGS', label: 'Furniture and Fittings' },
  { value: 'BUILDING_RESIDENTIAL', label: 'Residential Building' },
  { value: 'BUILDING_OTHER', label: 'Other Building' },
  { value: 'INTANGIBLE_ASSETS', label: 'Intangible Assets' },
  { value: 'MOTOR_CAR', label: 'Motor Car' },
  { value: 'OTHER', label: 'Other' },
];

export const INCOME_TAX_HEAD_OPTIONS = [
  { value: 'DIVIDEND', label: 'Dividend' },
  { value: 'INTEREST', label: 'Interest' },
  { value: 'OTHER_SOURCES', label: 'Other Sources' },
];

export const getOptionLabel = (options, value, fallback = '-') => {
  const match = options.find((option) => option.value === value);
  return match ? match.label : fallback;
};